import EditIcon from '@mui/icons-material/EditRounded';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import DeleteIcon from '@mui/icons-material/DeleteRounded';
import { Typography } from '@components/Typography';
import ActionIconButton from '@components/ActionIconButton';
import { Card, CardFooter, CardControls, CardIconButton, CardDivider } from '@components/CardItem/styles';
import { useTranslation } from '@hooks';
import { AgentStatus } from '@constants/agents';

const TemplateItem = ({ data, canWrite, isSubmitting, onClickCard }) => {
    const { t } = useTranslation();

    const StatusMap = {
        [AgentStatus.Active]: t('common.active'),
        [AgentStatus.Disabled]: t('common.disabled'),
    };

    return (
        <Card>
            <Typography variant="subtitle2" sx={{ marginBottom: '16px' }}>
                {data.name}
            </Typography>
            <CardDivider />
            <CardFooter>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="caption" sx={{ color: 'var(--text-secondary)' }}>
                        <span
                            style={{
                                ...(data.status === AgentStatus.Active && { backgroundColor: '#4CC474' }),
                                ...(data.status === AgentStatus.Disabled && { backgroundColor: '#FF5853' }),
                                display: 'inline-block',
                                height: 8,
                                width: 8,
                                borderRadius: '50%',
                                marginRight: 8,
                            }}
                        />
                        <span>
                            {data.status === AgentStatus.Active && data.inBusinessHours
                                ? t('Agents.activeInBusinessHours')
                                : StatusMap[data.status]}
                        </span>
                    </Typography>
                </div>
                <CardControls columns={canWrite ? 3 : 1}>
                    {canWrite ? (
                        <>
                            <ActionIconButton
                                title={data.status === AgentStatus.Active ? t('buttons.disable') : t('buttons.enable')}
                                component={CardIconButton}
                                disabled={isSubmitting}
                                onClick={() => onClickCard(data, 'toggleStatus')}
                            >
                                {data.status === AgentStatus.Active ? <PauseIcon /> : <PlayArrowIcon />}
                            </ActionIconButton>
                            <ActionIconButton
                                title={t('common.edit')}
                                component={CardIconButton}
                                disabled={isSubmitting}
                                onClick={() => onClickCard(data, 'edit')}
                            >
                                <EditIcon />
                            </ActionIconButton>
                            <ActionIconButton
                                title={t('common.delete')}
                                component={CardIconButton}
                                disabled={isSubmitting}
                                onClick={() => onClickCard(data, 'delete')}
                            >
                                <DeleteIcon />
                            </ActionIconButton>
                        </>
                    ) : (
                        <ActionIconButton
                            title={t('common.view')}
                            component={CardIconButton}
                            disabled={isSubmitting}
                            onClick={() => onClickCard(data, 'view')}
                        >
                            <VisibilityIcon />
                        </ActionIconButton>
                    )}
                </CardControls>
            </CardFooter>
        </Card>
    );
};

export default TemplateItem;
